import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { designSystem } from '@yola/ws-ui';
import { i18next, view } from '@yola/ws-sdk';
import OptionSection from 'src/js/modules/common/components/option-section';
import prepareInstructionsForColumnWidthReset from 'src/js/modules/extensions/registry/ws-column/helpers/prepare-instructions-for-column-width-reset';
import { COLUMN_WIDTH_ATTRIBUTE } from 'src/js/modules/extensions/registry/ws-column/constants';
import ElementSettingsContext from '../../../helpers/element-settings-context';

const { TabSelector, Box } = designSystem;

const ATTRIBUTE = 'layout';
const valueMap = {
  1: '1-columns',
  2: '2-columns',
  3: '3-columns',
  4: '4-columns',
  5: '5-columns',
  6: '6-columns',
};
const defaultOption = {};

function ColumnsAmountOption({ elementId = null, option = defaultOption, settingId = '' }) {
  const { state, updateState, callbacks } = useContext(ElementSettingsContext);

  const attrValue =
    get(state, `${elementId}.${ATTRIBUTE}`) ||
    view.accessors.getElementAttribute(elementId, ATTRIBUTE);
  let selected = Number(Object.keys(valueMap).find((key) => valueMap[key] === attrValue));
  const columns = view.accessors.getLiveElement(elementId);
  const customWidthColumns = columns.querySelectorAll(`ws-column[${COLUMN_WIDTH_ATTRIBUTE}]`);
  if (customWidthColumns.length) {
    selected = null;
  }

  const onClick = (value) => {
    const newState = {
      [elementId]: {
        [ATTRIBUTE]: valueMap[value],
      },
    };

    // If the columns have custom width, we need to remove it when changing the number of columns
    customWidthColumns.forEach((column) => {
      const columnId = view.accessors.getLiveElementId(column);
      newState[columnId] = {
        [COLUMN_WIDTH_ATTRIBUTE]: false,
      };
    });

    const instructions = prepareInstructionsForColumnWidthReset(elementId);

    updateState(option, {
      ...newState,
      ...instructions,
    });

    callbacks.onOptionClicked({ optionId: option.id, settingId });
  };

  const paddingProps = {
    paddingTop: 'spacing-xs',
    paddingLeft: 'spacing-m',
    paddingRight: 'spacing-m',
    paddingBottom: 'spacing-xs',
  };

  return (
    <Box {...paddingProps}>
      <OptionSection title={i18next.t('Columns per row')} wrap bold popoverProps={option.popover}>
        <Box marginTop="spacing-2-xs">
          <TabSelector selectedId={selected} disabledTabs={[5]} onClick={onClick} />
        </Box>
      </OptionSection>
    </Box>
  );
}

ColumnsAmountOption.propTypes = {
  elementId: PropTypes.string,
  option: PropTypes.shape(),
  settingId: PropTypes.string,
};

export default ColumnsAmountOption;
